import { render, staticRenderFns } from "./Web-app.vue?vue&type=template&id=3b2da26c&scoped=true&"
import script from "./Web-app.vue?vue&type=script&lang=js&"
export * from "./Web-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2da26c",
  null
  
)

export default component.exports